import request from './axios'
// /notice/management公告管理
export const noticeManagement =  (params) => {
        return request({
            url: "/notice/management",
            method: "post",
            data: params,
        })
}

// /notice/delete 删除公告
export const noticeManagementDelete = (params) => {
	return request({
		url: `/notice/deleteNotice`,
		method: "delete",
		params
	})
}

//​/schoolOrUserManagement​/studentList学生管理
export const schoolOrUserManagementList = (params) => {
    return request({
        url:"/schoolOrUserManagement/studentList",
        method:"post",
        data:params
    })
}

///schoolOrUserManagement​/teacherList 教师管理
export const schoolOrUserManagementTeacherList = (params) => {
    return request({
        url:"/schoolOrUserManagement/teacherList",
        method:"post",
        data:params
    })
}


// 围栏信息-查询
export const railInfoFind = (params) => {
    return request({
      url: `/setSystem/railInfo/find`,
      method: "get",
      params:params,
    });
  };

// 围栏信息-查询
export const railInfoUpdate = (params) => {
    return request({
      url: `/setSystem/railInfo/update`,
      method: "post",
      data:params,
    });
  };
  //读卡器管理
  export const readerCardList = (params) => {
      return request({
          url: `/readerCard/list`,
          method: "post",
          data:params,
        });
  }
  ///readerCard/delete 读卡器删除
  export const readerCardDelete = (params) => {
      return request({
          url: `/readerCard/delete`,
          method: "delete",
          params,
        });
    }
 // /readerCard/add读卡器详细信息-新增
    export const readerCardAdd = (params) => {
        return request({
            url: `/readerCard/add`,
            method: "post",
            data:params,
        });
    }
///readerCard/baseInfo 读卡器详细信息
export const readerCardBaseInfo= (params) => {
    return request({
        url: `/readerCard/baseInfo`,
        method: "get",
        params,
      });
}
///readerCard/update读卡器详细信息-修改
export const readerCardUpdate = (params,id) => {
    return request({
        url: `/readerCard/update?id=${id}`,
        method: "post",
        data:params,
      });
}


//读卡点管理
export const readerCardPointList = (params) => {
    return request({
        url: `/readerCard/pointList`,
        method: "post",
        data:params,
      });
}
//​/readerCard​/point​/delete读卡点-删除
export const readerCardPointDelete= (params) => {
    return request({
        url: `/readerCard/point/delete`,
        method: "delete",
        params,
      });
}
///readerCard/point/addOrUpdate 读卡点修改新增
export const readerCardPointAddOrUpdate= (params) => {
    return request({
        url: `/readerCard/point/addOrUpdate`,
        method: "post",
        data:params,
      });
}
///readerCard/point/baseInfo读卡点基本信息查询
export const readerCardPointbaseInfoe= (params) => {
    return request({
        url: `/readerCard/point/baseInfo`,
        method: "get",
        params,
      });
}


// 读卡点添加读卡器列表
export const CardAddValue= (params) => {
  return request({
      url: `/readerCard/point/addReaderList`,
      method: "get",
      params,
    });
}
// 读卡点添加读卡器
export const addReader= (params) => {
   return request({
     url: `/readerCard/point/addReader`,
     method: "post",
     data:params,
    });
  }
//添加读卡器id
export const readerCardAddInfo= (params) => {
  return request({
      url: `/readerCard/point/addReaderList`,
      method: "get",
      params,
    });
}

//学校新增
export const schoolOrUserAdd= (params) => {
    return request({
        url: `/schoolOrUserManagement/addSchool`,
        method: "post",
        data:params,
      });
}

//学校修改详情
export const schoolOrUserSchoolInfo= (params) => {
    return request({
        url: `/schoolOrUserManagement/findSchoolInfo`,
        method: "get",
        params,
      });
}
//学校信息修改
export const schoolInfoXiugai= (params) => {
    return request({
        url: `/schoolOrUserManagement/updateSchoolInfo`,
        method: "post",
        data:params,
      });
}
// 学校信息删除
export const schoolInfodelete= (params) => {
    return request({
        url: `/schoolOrUserManagement/deleteSchoolInfo`,
        method: "delete",
        params,
      });
}

// 围栏信息-删除
export const railInfoDelete= (params) => {
    return request({
        url: `/setSystem/railInfo/delete`,
        method: "post",
        data:params,
      });
}
// 学校组织管理-导入
export const importSchoolInfo= (params,id) => {
    return request({
        url: `/schoolOrUserManagement/importSchoolInfo?userId=${id}`,
        method: "post",
        data: params,
      });
}
// 学校组织管理-导出
export const exportSchoolInfo= (params,id) => {
    return request({
        url: `/schoolOrUserManagement/exportSchoolInfo`,
        method: "get",
        responseType: 'blob',
        params,
      });
}

//学生rfid绑定
export const studentRfidAdd= (imei,studentId) => {
    return request({
        url: `/schoolOrUserManagement/studentRfid/binding?imei=${imei}&&studentId=${studentId}`,
        method: "post",
        // data: params,
      });
}
//学生rfid解除

export const studentjiechuRfid= (params) => {
  return request({
      url: `/schoolOrUserManagement/studentRfid/deleteRelevance?studentId=${params}`,
      method: "post",
      // data:params,
    });
}
//  老师信息删除
export const deleteTeacherInfo= (params) => {
    return request({
        url: `/schoolOrUserManagement/deleteTeacherInfo`,
        method: "delete",
        data: params,
      });
}
//考勤管理列表
export const attendanceList= (params) => {
    return request({
        url: `/attendance/managementList`,
        method: "post",
        data: params,
      });
}
//考勤管理删除
export const attendanceDelete= (id) => {
    return request({
        url: `/attendance/delete?id=${id}`,
        method: "post",
        // data: params,
      });
}
//考勤统计
// export const attendanceDeleteTongJi= (params) => {
//     return request({
//         url: `/attendance/list`,
//         method: "post",
//         data: params,
//       });
// }
// 考勤统计
export const schoolListTongji= (params) => {
    return request({
        url: `/attendance/schoolList`,
        method: "post",
        data: params,
      });
}

//年级考勤统计
export const gradeListTongji= (params) => {
  return request({
      url: `/attendance/gradeList`,
      method: "post",
      data: params,
    });
}
//班级考勤统计
export const classListTongji= (params) => {
  return request({
      url: `/attendance/classList`,
      method: "post",
      data: params,
    });
}
//考试成绩列表
export const JxtattendanceList= (params) => {
    return request({
        url: `/examScore/list`,
        method: "post",
        data: params,
      });
}

//考勤时间列表
export const schoolTimeUserList= (params) => {
    return request({
        url: `/schoolOrUserManagement/attendanceTimeList`,
        method: "get",
      params,
      });
}
//学校考勤短信设置
export const schoolAttendanceMsgSet= (params) => {
    return request({
        url: `/schoolOrUserManagement/schoolAttendanceMsgSet`,
        method: "post",
        data:params,
      });
}
// 考勤时间-新增
export const attendanceTimeSet= (params) => {
    return request({
        url: `/schoolOrUserManagement/attendanceTimeSet`,
        method: "post",
        data:params,
      });
}
//考试成绩导入
export const examScoreImport= (params,classId,address,gradeId,schoolId,userId) => {
      return request({
        url: `/examScore/import?classId=${classId}&gradeId=${gradeId}&schoolId=${schoolId}&userId=${userId}`,
        method: "post",
        data: params,
       });
    }
    //考试成绩详细信息查询
export const examScoreBaseInfo= (params) => {
      return request({
        url: `/examScore/baseInfo`,
        method: "get",
        params,
      });
      }
    //考试成绩 修改
export const examScoreUpdate= (params) => {
      return request({
        url: `/examScore/update`,
        method: "post",
        data:params,
      });
      }
    //考试成绩 删除
export const examScoreDelete= (params) => {
      return request({
        url: `/examScore/delete`,
        method: "DELETE",
        params,
      });
      }
  

    //考勤时间 - 修改
    export const attendanceTimeUpdate= (params) => {
      return request({
        url: `/schoolOrUserManagement/attendanceTime/update`,
        method: "post",
        data: params,
       });
    }
    //考勤时间 - 删除
    export const attendanceTimeDelete= (params) => {
      return request({
        url: `/schoolOrUserManagement/attendanceTime/delete`,
        method: "post",
        data: params,
       });
    }

    //新闻安全
    export const noticeList= (params) => {
      return request({
        url: `/notice/list`,
        method: "post",
        data: params,
       });
    }
    //新闻安全删除
    export const noticeListDelete= (params) => {
      return request({
        url: `/notice/delete`,
        method: "delete",
        params,
       });
    }
        //文件获取地址
        export const uploadImage= (params,fileName) => {
          return request({
            url: `/app/uploadImage?fileName=${fileName}`,
            method: "post",
            data: params,
           });
        }
     //新闻安全 新增
  export const noticeCreate= (params) => {
    return request({
      url: `/notice/create`,
      method: "post",
      data:params,
     });
  }
  //新闻安全 详情
  export const noticeDetails= (params) => {
    return request({
      url: `/notice/details`,
      method: "get",
      params,
     });
  }
  //新闻安全 修改
  export const noticeUpdate= (params) => {
    return request({
      url: `/notice/update`,
      method: "post",
      data:params,
     });
  }
       //家庭作业 列表
  export const homeworkList= (params) => {
    return request({
      url: `/homework/list`,
      method: "post",
      data:params,
     });
  }
  //家庭作业 列表
  export const homeworkPublish= (params) => {
    return request({
      url: `/homework/publish`,
      method: "post",
      data:params,
     });
  }
  //家庭作业 删除
  export const homeworkDelete= (params) => {
    return request({
      url: `/homework/delete`,
      method: "delete",
      params,
     });
  }
  
  
  //  添加科目接口
  export const subjectAdd= (params) => {
    return request({
      url: "/subject/add",
      method: "post",
      data:params,
     });
  }
  
  //获取科目列表接口
  export const addTeacherJob = (params) => {
    return request({
      url: "/schoolOrUserManagement/addTeacherJob",
      method: "post",
      data:params
     });
  }
  
  
  //获取科目列表接口
  export const subjectList= (params) => {
    return request({
      url: "/subject/list",
      method: "post",
      params
     });
  }
  
  //编辑科目接口
  export const subjectUpdate= (params) => {
    return request({
      url: "/subject/update",
      method: "post",
      data:params,
     });
  }
  //删除科目接口
  export const subjectDelete= (params) => {
    return request({
      url: "/subject/delete",
      method: "delete",
      params,
     });
  }
  
  //围栏设置获取 
  export const getRegionTree= (params) => {
    return request({
      url: `/menu/getRegionTree`,
      method: "get",
      params,
     });
  }
  //围栏设置 新增
  export const circleAdd= (params) => {
    return request({
      url: `/device/circle/add`,
      method: "post",
      params,
     });
  }

//批量下发人脸
export const batchIssuedFace= (params) => {
  return request({
    url: `/Subscribe/batchIssuedFace`,
    method: "post",
    headers: {'Content-Type': 'application/json'},
    data: params
   });
}

//批量重启设
export const rebootFaceDevice= (params) => {
  return request({
    url: `Subscribe/rebootFaceDevice `,
    method: "post",
	headers: {'Content-Type': 'application/json'},
    data: params
   });
}
//教师批量导入

export const ImporBulkTeacher= (params,id) => {
  return request({
      url: `/schoolOrUserManagement/importTeacher?userId=${id}`,
      method: "post",
      data: params,
	  responseType: 'blob'
    });
}

// 楼栋新增
export const AddBuilding = (params) => {
  return request({
    url: `/buildingDormitory/building/add`,
    method: "post",
    data:params,

   });
}

// 楼栋列表查询
export const LoDongBuildingList = (params) => {
  return request({
    url: `/buildingDormitory/buildingList`,
    method: "post",
    data:params,

   });
}
//楼栋删除
export const LoDongBuildingDelete= (id) => {
  return request({
      url: `/buildingDormitory/building/delete?id=${id}`,
      method: "delete",
      // data: params,
    });
}

// 楼栋修改
export const UpdateBuilding = (params) => {
  return request({
    url: `/buildingDormitory/building/update`,
    method: "post",
    data:params,

   });
}
//宿舍列表查询
export const SusheDormitoryList = (params) => {
  return request({
    url: `/buildingDormitory/dormitoryList`,
    method: "post",
    data:params,

   });
}

//清空宿舍

export const DormitoryClearSushe= (dormitoryId ) => {
  return request({
      url: `/buildingDormitory/dormitoryClear?dormitoryId=${dormitoryId}`,
      method: "post",
      // data: params,
    });
}
//宿舍删除
export const dormitoryDelete= (data) => {
   return request({
     url: `/buildingDormitory/dormitory/delete`,
     method: "delete",
     data,
    });
  }
  //打卡进出记录
export const RecordList = (params) => {
  return request({
    url: `/buildingDormitory/dormitory/record`,
    method: "post",
    data:params,

   });
}

 // 新增宿舍保存接口
export const dormitoryAdd = (params) => {
 return request({
  url: `/buildingDormitory/dormitory/add`,
  method: "post",
  data:params,

 });
}
 //归属楼栋列表
export const buildingList = (params) => {
 return request({
  url: `/buildingDormitory/buildingList`,
  method: "post",
  data:params,
 });
}
 //学生列表
export const studentList = (params) => {
 return request({
  url: `/buildingDormitory/dormitory/studentList`,
  method: "post",
  data:params,
 });
}

 // 宿舍查询添加的学生
export const findStudent = (dormitoryId) => {
 return request({
  url: `/buildingDormitory/dormitory/findStudent?dormitoryId=${dormitoryId}`,
  method: "post",
 });
}
 //宿舍添加/删除学生
export const addStudent = (params,dormitoryId) => {
 return request({
  url: `/buildingDormitory/dormitory/addStudent?dormitoryId=${dormitoryId}`,
  method: "post",
  data:params,
 });
}
 //学生月考勤
 export const MonthAttendanceList = (params) => {
  return request({
   url: `/attendance/monthAttendanceList`,
   method: "post",
   data:params,
  });
 }

 // 请假管理列表
 export const schoolOrUserManagementleavePage = (params) => {
  return request({
    url: `/schoolOrUserManagement/leavePage`,
    method: "post",
    data: params,
  });
 }
